import React, { useState } from "react";
import { Input, Card, Button, Row, Col, message } from "antd";

// Declare global constants injected by Vite define
declare const API_BASE_URL: string;

const { TextArea } = Input;

export const VectorEditor: React.FC = () => {
  const [code, setCode] = useState(""); // User enters code here
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLoadCode = async () => {
    if (!code.trim()) {
      message.warning("Please enter a code before loading.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/load-vector?code=${code}`);
      const data = await response.json();

      if (response.ok) {
        setShortDescription(data.data.short_description || "No short description available.");
        setLongDescription(data.data.long_description || "No long description available.");
        message.success("Code loaded successfully!");
      } else {
        message.error(data.detail || "Code not found.");
      }
    } catch (error) {
      console.error("Error fetching code:", error);
      message.error("Failed to load code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!code.trim()) {
      message.warning("Please enter a code before saving.");
      return;
    }
  
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/update-vector`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code,
          short_description: shortDescription, // State variable for short description
          long_description: longDescription, // State variable for long description
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        message.success("Descriptions updated successfully!");
      } else {
        message.error(data.detail || "Failed to update vector.");
      }
    } catch (error) {
      console.error("Error updating vector:", error);
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div style={{ width: "100%", padding: "20px" }}>
      <div style={{ padding: "20px", borderRadius: "8px" }}>
        <Row gutter={[16, 16]} justify="center" style={{ marginTop: "20px" }}>
          <Col xs={24} sm={24} md={16} lg={12}>
            <Card 
              variant="outlined" 
              style={{ textAlign: "center", boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)" }}
            >
              <Input
                placeholder="Enter Code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                style={{ marginBottom: "10px" }}
              />
              <Button type="default" onClick={handleLoadCode} loading={loading}>
                {loading ? "Loading..." : "Load Code"}
              </Button>

              <TextArea
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
                rows={3}
                placeholder="Short Description"
                style={{ marginTop: "20px" }}
              />

              <TextArea
                value={longDescription}
                onChange={(e) => setLongDescription(e.target.value)}
                rows={10}
                placeholder="Long Description"
                style={{ marginTop: "10px" }}
              />

              <Button type="default" onClick={handleSave} style={{ marginTop: "10px" }}>
                Save
              </Button>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};
